import React from 'react';

function TwitterSvg({ className }) {
  return (
    <svg
      className={className}
      width="108"
      height="58"
      viewBox="0 0 108 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M103.085 5.04483C98.8152 8.05638 94.0881 10.3597 89.0853 11.8662C86.4002 8.77879 82.8317 6.59052 78.8624 5.59734C74.893 4.60417 70.7145 4.85399 66.8918 6.31304C63.0691 7.77208 59.7867 10.3699 57.4886 13.7553C55.1905 17.1406 53.9875 21.15 54.0423 25.2414V29.6997C46.2073 29.9029 38.4436 28.1652 31.4428 24.6415C24.4419 21.1177 18.4212 15.9172 13.9168 9.50323C13.9168 9.50323 -3.91679 49.6288 36.2088 67.4623C27.0268 73.695 16.0887 76.8202 5 76.3791C45.1255 98.6711 94.1679 76.3791 94.1679 25.1076C94.1638 23.8657 94.0444 22.6269 93.8112 21.4071C98.3615 16.9197 101.572 11.2541 103.085 5.04483Z"
        stroke="#F7F6F6"
        strokeWidth="8.91679"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TwitterSvg;
